// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"5b7ed458","225":"95ee8429","272":"26cefa5b","372":"2ebab333","377":"c0c3400f","572":"43371598","573":"02755ddb","738":"240d0c36","841":"e06f4c5f","856":"3c710a7d","862":"793e052a","883":"d15e2439"}[chunkId] + ".chunk.js";
};